import { render, staticRenderFns } from "./EAE_Fee_Reduction_Policy.vue?vue&type=template&id=6544714b&scoped=true&"
import script from "./EAE_Fee_Reduction_Policy.vue?vue&type=script&lang=js&"
export * from "./EAE_Fee_Reduction_Policy.vue?vue&type=script&lang=js&"
import style0 from "./EAE_Fee_Reduction_Policy.vue?vue&type=style&index=0&id=6544714b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6544714b",
  null
  
)

export default component.exports